export const GAMES = {
  TEST_GAME: "5f43b2f5-71f9-4e96-bbca-9ce1c9da6cfc",
  BADMAD_ROBOTS: "550e8400-e29b-41d4-a716-446655440000",
};
